import gql from 'graphql-tag';
//agregar fecha de vigencia para apis
export const queryCliente = gql`
   query Cliente($codigoCliente: String!) {
      llavesDetalle(codigo: $codigoCliente) {
         codigo
         documento
         fechaExpiracion
         usuario
         anio
         fechaVigenciaApi
         producto
         modular
         ide
         mac
         cpu
         placa
         bios
         sisoper
         ram
         chip
         codHash
      }
   }
`;